
export interface UserPreferences {
  userId: string;
  defaultModule: string; // e.g. "contracts", "dashboard"
  defaultDateRangeDays: number; // 7, 30, 90
  notifyModules: string[]; // ["contract", "case", ...]
  theme?: "dark" | "light";
  updatedAt?: any;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  userId: "",
  defaultModule: "dashboard",
  defaultDateRangeDays: 30,
  notifyModules: ["contract", "case", "seal", "govCorrespondence", "task"]
};
